import { client } from "../client/client";

export const addSupportTicket = async (
  fullName,
  email,
  phoneNumber,
  impactedPlatform,
  deviceOrBrowser,
  stepsToReplicate,
  expectedResult,
  actualResult,
  addMoreInfo,
  usersImpacted,
  memberId,
  replicated,
  date,
  time,
  uploadedFiles
) => {
  try {
    const formData = new FormData();

    // Append text fields
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);
    formData.append("impactedPlatform", impactedPlatform);
    formData.append("deviceOrBrowser", deviceOrBrowser);
    formData.append("stepsToReplicate", stepsToReplicate);
    formData.append("expectedResult", expectedResult || "");
    formData.append("actualResult", actualResult || "");
    formData.append("addMoreInfo", addMoreInfo || "");
    formData.append("usersImpacted", usersImpacted || "");
    formData.append("memberId", memberId || "");
    formData.append("replicated", replicated || "");
    formData.append("date", date);
    formData.append("time", time);

    // Append files (can be multiple)
    if (uploadedFiles && uploadedFiles.length > 0) {
      Array.from(uploadedFiles).forEach((file) => {
        formData.append("files", file);
      });
    }
    const response = await client.post(`/api/support/tickets`, formData);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
